/**
 * Seen — "What ships when" manifest (06.09.2026, owner: "show rõ sản phẩm
 * nào in stock, sản phẩm nào preorder, timeline ship của từng item như PDP";
 * 19:23: "đoạn này hơi khó hiểu … charm có pre-order đâu").
 *
 * A PURE renderer: assets/afroyla-seen-buy.js hands it the chosen lines and
 * the section's strings, it hands back HTML. It knows nothing about the buy
 * box, the cart or the DOM, so it can be unit-tested with plain objects.
 *
 * ITEM-FIRST rows, one per ship group, earliest first:
 *     ● Free leather charm + leather wallet, Yemi Envelope Wallet — In stock · ships now
 *     ● Kora — Pre-order · ships Sep 29 – Oct 6 · 2 left
 *     ● Dunia ×2 — Pre-order · ships Oct 15 – 22
 * Pieces that ship together (same status, same window) share a row; the
 * names are listed backpacks → free gifts → companions. Every piece carries
 * its OWN status — a free charm that is in stock is never written into the
 * backpack's pre-order row.
 *
 * Under the rows, ONE note: the low-batch line when a chosen backpack is at
 * or under the threshold (real number, the design's name, its window), else
 * the open-run line while anything is on pre-order, else nothing.
 *
 * Truth rules (skills/afroyla-copywriting §7): every date and count comes
 * from the DOM attributes Liquid rendered out of `preorder.batches`; the
 * notes are merchant strings and carry no day count, no fake stat.
 */
(function () {
  'use strict';

  var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  var KIND_ORDER = { backpack: 0, gift: 1, companion: 2 };

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function fill(template, tokens) {
    var out = template || '';
    Object.keys(tokens).forEach(function (key) {
      out = out.split('{' + key + '}').join(tokens[key]);
    });
    return out;
  }

  /* "Sep 29 – Oct 6" → a sortable number (month*100 + day of the START).
     In stock sorts first (-1); unparseable windows sort last. */
  function windowKey(win) {
    var m = /^([A-Za-z]{3})[a-z]*\.?\s+(\d{1,2})/.exec(String(win || '').trim());
    if (!m) return 9999;
    var month = MONTHS.indexOf(m[1].toLowerCase());
    if (month < 0) return 9999;
    return month * 100 + parseInt(m[2], 10);
  }

  /* The status phrase for one line — the same words the picker rows use. */
  function statusText(line, copy) {
    if (!line.preorder) return copy.nowLine || 'In stock · ships now';
    if (!line.window) return copy.preNoDates || 'Pre-order';
    return fill(copy.preLine || 'Pre-order · ships {window}', { window: line.window });
  }

  /* Group lines that ship together: same status, same window. */
  function groups(lines) {
    var byKey = {};
    var order = [];
    lines.forEach(function (line) {
      var key = line.preorder ? 'pre:' + (line.window || '') : 'now';
      if (!byKey[key]) {
        byKey[key] = { preorder: !!line.preorder, window: line.preorder ? line.window || '' : '', lines: [] };
        order.push(key);
      }
      byKey[key].lines.push(line);
    });
    return order
      .map(function (key) {
        var g = byKey[key];
        g.lines.sort(function (a, b) {
          return (KIND_ORDER[a.kind] || 0) - (KIND_ORDER[b.kind] || 0);
        });
        return g;
      })
      .sort(function (a, b) {
        var ka = a.preorder ? windowKey(a.window) : -1;
        var kb = b.preorder ? windowKey(b.window) : -1;
        return ka - kb;
      });
  }

  /* The note under the rows — the low line beats the open line. */
  function noteFor(lines, copy) {
    var threshold = copy.lowThreshold || 20;
    var low = lines.filter(function (line) {
      return line.kind === 'backpack' && line.preorder && line.remaining != null && line.remaining > 0 && line.remaining <= threshold;
    });
    if (low.length && copy.lowNote) {
      low.sort(function (a, b) {
        return a.remaining - b.remaining;
      });
      var l = low[0];
      return fill(esc(copy.lowNote), {
        n: '<b>' + esc(l.remaining) + '</b>',
        name: esc(l.name),
        window: esc(l.window || ''),
      });
    }
    var anyPre = lines.some(function (line) {
      return line.preorder;
    });
    return anyPre && copy.openNote ? esc(copy.openNote) : '';
  }

  /**
   * @param {Array} lines  [{ name, kind: 'backpack'|'gift'|'companion', preorder, window, remaining }]
   * @param {Object} copy  { label, nowLine, preLine, preNoDates, lowLabel, lowThreshold, lowNote, openNote }
   * @returns {string} HTML, or '' when there is nothing to say
   */
  function html(lines, copy) {
    if (!lines || !lines.length) return '';
    var rows = groups(lines);
    if (!rows.length) return '';
    var out = '';
    if (copy.label) out += '<p class="afl-buy__ship-lbl">' + esc(copy.label) + '</p>';
    out += '<ul class="afl-buy__ship-list">';
    rows.forEach(function (g) {
      var names = g.lines
        .map(function (line) {
          return line.name;
        })
        .join(', ');
      var low = '';
      if (g.preorder && copy.lowThreshold) {
        g.lines.forEach(function (line) {
          if (line.kind === 'backpack' && line.remaining != null && line.remaining > 0 && line.remaining <= copy.lowThreshold) {
            low += ' <span class="afl-buy__low">' + esc(line.remaining + ' ' + (copy.lowLabel || 'left')) + '</span>';
          }
        });
      }
      var kind = g.preorder ? 'pre' : 'now';
      out +=
        '<li class="afl-buy__ship-row afl-buy__ship-row--' + kind + '">' +
        '<i class="afl-buy__dot afl-buy__dot--' + kind + '" aria-hidden="true"></i>' +
        '<b>' + esc(names) + '</b> <span class="afl-buy__ship-when">— ' + esc(statusText(g, copy)) + '</span>' +
        low +
        '</li>';
    });
    out += '</ul>';
    var note = noteFor(lines, copy);
    if (note) out += '<p class="afl-buy__ship-note">' + note + '</p>';
    return out;
  }

  window.AflSeenShip = { html: html, groups: groups, windowKey: windowKey };
})();
